module.exports = {
	message: {
        // 西班牙语
		home: {
			language: "español",
			keyword:'Palabra clave',
			hotPro:'Productos en caliente',
			product:'Principales productos',
			about:'sobre',
			aboutDesc:'Servicio al cliente, satisfacción del cliente',
			news:'Últimas noticias',
			company:'empresa',
			proVideo:'Vídeo promocional',
			certificate:'Certificado de certificado',
			factory:'Fábrica cooperativa'
		},
		about:{
			advantages:'Nuestras ventajas',
			factory:'Exposición de la fábrica',
			honors:'Honores y certificados',
			honorsDesc:'Perseguimos su objetivo de servirle mejor',
			title1:'Capacidad de producción',
			content1:'Planta de producción moderna, enorme y de propiedad total',
			title2:'Precio competitivo',
			content2:'Precio razonable, rendimiento de alto costo',
			title3:'Entrega rápida',
			content3:'Varios almacenes ubicados en el puerto de carga principal',
			title4:'Equipo profesional',
			content4:'Equipo profesional de desarrollo, producción y exportación',
			free1:'Servicios personalizados',
			frcon1:'El reciclaje de metales se refiere al procesamiento físico o mecánico de materiales útiles separados de chatarra de metales en productos recicl. Es una cadena industrial que va desde el reciclaje, el desmontaje hasta el reciclaje. La industria del reciclaje de metales ha formado una cadena industrial completa y un ecosistema de reciclaje. A medida que las economías emergentes adoptan gradualmente tecnologías y estilos de vida similares a los de los países de la OCDE, la demanda mundial de metales en el futuro llegará a 3 a 9 veces la cantidad de metales utilizados en todo el mundo. El reciclaje de productos metálicos complejos puede resolver y hacer frente a los desafíos provocados por el aumento de la demanda de metal.',
			free2:'Control de calidad',
			frcon2:'Los equipos de reciclaje de metales incluyen principalmente equipos de trituración y pulverización, equipos de clasificación, equipos de pretratamiento y equipos de procesamiento de regeneración, etc. Diferentes equipos juegan un papel clave en diferentes eslabdel reciclaje de metales. Estos equipos son ampliamente utilizados para procesar chatarra y mejorar la utilización de recursos, cubriendo una variedad de medios técnicos tales como trituración física, separación magnética, aplanado, etc.',
			free3:'Logística integral',
			frcon3:'El centro de reciclaje de metales de fábrica de nuestra compañía se especializa en el manejo de todo tipo de desechos metálicos y está comprometido con el reciclaje y refinde metales raros. La gama de reciclaje en la tienda cubre todo el mundo, proporcionando servicios prácticos como análisis de precios in situ y transacciones en efectivo. Nuestra empresa se centra en los residuos metálicos de alto contenido (90%), que pueden reciclarse independientemente de su peso o forma.',
			free4:'Inspección de terceros',
			frcon4:'Además del impacto ambiental de la minería y fundición de metales, también consume del 7% al 8% del suministro energético mundial. El reciclaje consume menos energía que la producción primaria de metales, al tiempo que reduce el impacto global en los sitios mineros. El reciclaje de metales también puede reducir la demanda de minerales de baja calidad, evitando la extracción de algunos metales preciosos que serán escasos en el futuro.',
			new1:'Noticias',
			new2:'Noticias de la empresa',
			new3:'Noticias de la industria'
		},
		service:{
			ourservice:'Nuestros servicios',
			questions:'Preguntas frecuentes',
			message:'Deja un mensaje',
			hours:'Por favor, siénlibre de dejar un mensaje. Le responderemos en 24 horas.',
			name:'Su nombre:',
			mail:'E-Mail:*',
			tel:'Tel/¿Cuál es la aplicación:',
			type:'Tipo de producto :*',
			video:'VIDEO',
			up:'Página anterior siguiente',
			next:'Página siguiente'
		},
		contact:{
			help:'Estamos aquí para ayudar',
			helpDesc:'Póngase en contacto con nosotros a través de la siguiente información de contacto',
			manager:'Gerente de ventas',
			phone:'Teléfono/¿Cuál es la aplicación/Wechat',
			sendeamil:'Enviar correo electrónico',
			ouraddress:'Nuestra dirección'
		}, 
		foot:{
			navigation:'Navegación rápida',
			type:'categorías',
			mobile:'Móvil (WHATSAPP/WECHAT)',
			email:'Correo electrónico',
			address:'Dirección dirección',
			number:'Número de la demanda',
			service:'Servicio de una parada, selección más fácil'
		},
		product:{
			description:'descripción',
			technical:'Especificaciones técnicas',
			advantages:'Ventajas',
			related:'Productos relacionados',
			videoDesc:'Fábrica de aleación de hierro de origen de China, la más alta calidad y el precio más bajo del mundo, alta comisión, agente sincero.',
			ti1:'Por favor, rellene la dirección de correo electrónico.',
			ti2:'Por favor, rellene el tipo.',
			ti3:'Por favor, rellene el contenido.'
		},
		nav:{
			home:'Inicio',
			about:'Sobre nosotros',
			products:'productos',
			news:'noticias',
			video:'Video',
			free:'Reciclaje y tecnología gratuita',
			contact:'Póngase en contacto con nosotros',
			vr:'VR',
			chat:'El Chat',
			whatsapp:'¿Cuál es la aplicación',
			wechat:'Wechat',
			message:'mensaje',
			tel:'Tel',
			top:'arriba',
		},
		btn:{
			read:'Leer más',
			news:'Más noticias',
			exhibition:'Más información',
			watchVideo:'Ver más vídeos',
			services:'servicios',
			products:'productos',
			contactus:'Póngase en contacto con nosotros',
			inquiry:'La investigación ahora',
			size:'tamaño',
			packing:'La embalaje',
			service:'Servicio en línea',
			submit:'enviar',
			sendEmial:'Enviar correo electrónico',
			now:'ahora',
			text1:'No dude en ponerse en contacto con nosotros en cualquier momento.',
			text2:'Diseñamos el contenido y la granularidad de los materiales que satisfsus necesidades.',
			text3:'Si usted necesita aumentar la seguridad, maximizar la capacidad de producción o confiabilidad, o reducir costos, nosotros entregamos.',
			text4:'Estamos dedicados a proporcionar un servicio al cliente excepcional y la entrega de productos de alta calidad a nuestros clientes valorados.',
			text5:'Centrarse en la producción de Ferro silicio y silimetal de alta calidad',
			text6:'* consejos: 1. ¿Qué producto necesita? 2. ¿Qué proyecto piensas hacer? 3. ¿Cuándo va a necesitar este producto?'
		}
    }
};
